import { ArrowLeft } from 'lucide-react';

export type HelpArticleDetail = {
  title: string;
  slug: string;
  summary?: string;
  body: string;
  category_title?: string;
  updated_on?: string | null;
};

export default function HelpArticleView({
  article,
  onBack,
}: {
  article: HelpArticleDetail;
  onBack: () => void;
}) {
  return (
    <article className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Back
        </button>
        {article.category_title ? (
          <span className="text-[10px] font-bold uppercase tracking-wide text-primary-700 bg-primary-50 border border-primary-100 rounded-full px-2 py-0.5">
            {article.category_title}
          </span>
        ) : null}
      </div>
      <div className="p-5 md:p-6 space-y-3">
        <h2 className="text-xl font-black text-gray-900 tracking-tight">{article.title}</h2>
        {article.summary ? <p className="text-sm text-gray-500">{article.summary}</p> : null}
        {article.updated_on ? (
          <p className="text-[11px] text-gray-400">Updated {String(article.updated_on).slice(0, 16)}</p>
        ) : null}
        <div
          className="prose prose-sm max-w-none text-gray-700 prose-headings:text-gray-900 prose-a:text-primary-600"
          dangerouslySetInnerHTML={{ __html: article.body || '' }}
        />
      </div>
    </article>
  );
}
